import { FC } from "react";

export type FunctionType = {
  icon: string;
  name: string;
  description: string;
};

type Props = {
  value: FunctionType;
};

const FunctionItem: FC<Props> = ({
  value: { icon, name, description },
}): JSX.Element => {
  return (
    <div className="flex laptop:justify-center laptop:items-center laptop:flex-col gap-16 laptop:gap-32">
      <div
        className="flex-shrink-0 bg-white rounded-full w-[80px] h-[80px] laptop:w-[200px] laptop:h-[200px] flex items-center justify-center"
        style={{
          boxShadow: "0px 0px 70px 0px #EBEBEB",
        }}
      >
        <div className="w-[40%]">
          <img className="w-full h-auto" src={icon} alt={name} />
        </div>
      </div>
      <div className="space-y-4 laptop:space-y-12">
        <h2 className="laptop:text-center font-bold text-[18px] laptop:text-[30px]">
          {name}
        </h2>
        <p className="font-bold text-[14px] laptop:text-[20px] leading-[187.5%] laptop:max-w-[280px]">
          {description}
        </p>
      </div>
    </div>
  );
};
export default FunctionItem;
